import Nav from "./Nav";
import AboutDesc from "./AboutDesc";
import AboutSkills from "./AboutSkills";
import iconTailwind from "../images/pngwing.com.png"
import Diploms from "./Diploms";
import Experiences from "./Experiences";
export default function About() {
    return (
        <>
            <Nav />
            <div className="about">
                <AboutDesc />
                <div className="aboutSkills">
                    <AboutSkills logo={"fa-brands fa-html5"} lang={"HTML5"} />
                    <AboutSkills logo={"fa-brands fa-css3-alt"} lang={"CSS3"} />
                    <AboutSkills logo={"fa-brands fa-js"} lang={"JS"} />
                    <AboutSkills logo={"fa-brands fa-php"} lang={"PHP"} />
                    <AboutSkills logo={"fa-brands fa-react"} lang={"REACT JS"} />
                    <AboutSkills logo={"fa-brands fa-laravel"} lang={"LARAVEL"} />
                    <AboutSkills logo={"fa-brands fa-bootstrap"} lang={"BOOTSTRAP"} />
                    <AboutSkills logo={"fa-brands fa-jira"} lang={"JIRA"} />
                    <AboutSkills logo={"fa-brands fa-git"} lang={"GIT"} />
                </div>
            </div>
            <Diploms />
            <Experiences />
        </>
    );
}